<template>
  <div class="order-log" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" inline :model="form" ref="form">
      <el-form-item label="操作时间" prop="time">
        <el-date-picker
          v-model="form.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="memberName">
        <el-input v-model="form.memberName" placeholder="请输入客户姓名"></el-input>
      </el-form-item>
      <el-form-item label="订单号" prop="orderNo">
        <el-input v-model="form.orderNo" placeholder="请输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="IP地址" prop="ipAdd">
        <el-input v-model="form.ipAdd" placeholder="请输入IP地址"></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="itemName">
        <el-input v-model="form.itemName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="IP区域" prop="area">
        <el-input v-model="form.area" placeholder="请输入IP区域(省 市)"></el-input>
      </el-form-item>
      <el-form-item label="公司所在地" prop="registeredAddress">
        <el-input v-model="form.registeredAddress" placeholder="请输入公司所在地"></el-input>
      </el-form-item>
      <el-form-item label="来源" prop="source">
        <el-select v-model="form.source" placeholder="请选择">
          <el-option
            v-for="item in sourceArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="userName"
        label="用户名"
        width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="memberName"
        label="客户名称"
        width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="商品名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="ipAdd"
        label="IP地址"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="area"
        label="区域"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="registeredAddress"
        label="公司所在地"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="source"
        label="来源"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="operationTime"
        label="操作时间"
        width="160"
        :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listState.total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
      <div class="output-box" v-permission="'0010801'">
        每页<el-select class="select-page" v-model="form.pageSize" placeholder="请选择条数">
          <el-option
            v-for="item in sizeArr"
            :key="item.value"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>条
        第<el-select class="select-page" v-model="form.pageNo" placeholder="请输入页码">
          <el-option
            v-for="item in sizeNumber"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>页
        <!-- 第<el-input class="input-page" type="number" v-model="form.pageNo" placeholder="请输入页码"></el-input>页 -->
        <el-button class="select-page-btn" type="primary" @click="handleExport()">导出为CSV文件</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'tripartiteLog',
  data () {
    return {
      form: {
        time: '',
        userName: '',
        orderNo: '',
        itemName: '',
        memberName: '',
        ipAdd: '',
        area: '',
        registeredAddress: '',
        source: '',
        pageNo: 1,
        pageSize: 1000
      },
      sizeArr: [
        { value: '', label: '1000' },
        { value: 1, label: '5000' },
        { value: 2, label: '10000' },
        { value: 3, label: '20000' }
      ],
      sourceArr: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'B2B商城app ios端',
          label: 'B2B商城app ios端'
        },
        {
          value: 'B2B商城app  android端',
          label: 'B2B商城app  android端'
        },
        {
          value: 'B2B商城web端',
          label: 'B2B商城web端'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      list: state => state.orderLog.list,
      listState: state => state.orderLog.listState
    }),
    sizeNumber () {
      const maxNo = Math.ceil(this.listState.total / this.form.pageSize) + 1
      const newArr = [...new Array(maxNo).keys()]
      newArr.shift()
      return newArr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getOrderLog', 'exportOrderLogQuery', 'queryDictListInfoByCode']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1,
        pageSize: 10
      }
      this.getOrderLog(params)
    },
    reset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getOrderLog({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getOrderLog({ pageNo: val })
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportOrderLogQuery({ ...this.form }).then((res) => {
          function createDownloadFile () {
            let blobObject = new Blob([res])
            let fileName = '客户下单记录报表.xls'
            // 兼容 IE系列 浏览器
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blobObject, fileName)
            } else {
              let link = document.createElement('a')
              link.download = fileName
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blobObject)
              console.log(link)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }
          createDownloadFile()
          this.$message.success('导出成功')
          this.form.pageNo = 1
          this.form.pageSize = 1000
        })
      })
        .catch(() => {
        })
    }
  }
}
</script>

<style scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
</style>
